import axios from 'axios'
import { ENDPOINTS_STUDENT } from './urls'
import { autoReplace, checkError } from 'utils'

export const getChildren = async () => {
  const url = ENDPOINTS_STUDENT.ME_CHILDREN
  const { data } = await axios.get(url)
  return data
}

export const getChildrenId = async (id) => {
  checkError({ id })
  const correction = {
    [':childId']: id,
  }
  const url = autoReplace(ENDPOINTS_STUDENT.ME_CHILDREN_CHILD_ID, correction)
  const { data } = await axios.get(url)
  return data
}

export const setChildDataRelative = async ({ data, id, isPersonalData }) => {
  const url = isPersonalData
    ? `/bk/me/children/${id}`
    : `/bff-vle/student/children/${id}/login`
  await axios.patch(url, data)
}

export const postChangePasswordChild = async ({
  childrenId,
  newPassword1,
  newPassword2,
}) => {
  const correction = {
    [':childrenId']: childrenId,
  }
  const url = autoReplace(ENDPOINTS_STUDENT.STUDENT_CHILDREN_LOGIN, correction)
  await axios.patch(url, { newPassword1, newPassword2 })
}

export const getStudentsAndValidationRequests = async ({ classroomId }) => {
  const correction = {
    [':classroomId']: classroomId,
  }
  const url = autoReplace(
    ENDPOINTS_STUDENT.STUDENTS_VALIDATION_REQUESTS,
    correction
  )
  const { data } = await axios.get(url)
  return data
}

export const getStudentsFromAClass = async ({ classId }) => {
  const correction = {
    [':classId']: classId,
  }
  const url = autoReplace(ENDPOINTS_STUDENT.STUDENT_IN_CLASS, correction)
  const { data } = await axios.get(url)
  return data
}

export const getStudent = async ({ userId }) => {
  const url = `/bk/students/${userId}`
  const { data } = await axios.get(url)
  return data
}

export const patchStudentValidation = async ({
  newStatus,
  updateStudentValidationRequestsIds,
}) => {
  const url = '/bk/me/studentValidationRequests'
  const { data } = await axios.patch(url, {
    newStatus,
    updateStudentValidationRequestsIds,
  })
  return data
}

export const courses = async (studentID) => {
  checkError({ studentID })
  const url = `/bk/schools/${studentID}/courses`
  const response = await axios.get(url)
  return response
}

export const getCourses = async (schoolId) => {
  const url = ENDPOINTS_STUDENT.COURSES.replace(':schoolId', schoolId)
  const { data } = await axios.get(url)
  return data
}

export const postStudentCourses = async (studentId, courseId) => {
  const url = ENDPOINTS_STUDENT.STUDENT_COURSES.replace(':studentId', studentId)
  const response = await axios.post(url, { courseId })
  return response
}

export const students = async ({ schoolCodeId, data }) => {
  const url = `/bk/schools/${schoolCodeId}/students`
  const response = await axios.post(url, { ...data })
  return response
}

export const studentsUnder14 = async (data) => {
  const url = '/bff-vle/studentsUnder14'
  const response = await axios.post(url, { ...data })
  return response
}

export const updateCourses = async (schoolCodeId, courseId) => {
  checkError({ schoolCodeId })
  const url = `/bk/students/${schoolCodeId}/courses`
  const response = await axios.post(url, { courseId })
  return response
}

export const updateClassrooms = async ({ classroomId, data }) => {
  checkError({ classroomId })
  const url = `/bk/classrooms/${classroomId}/students`
  const response = await axios.post(url, { ...data })
  return response
}

export const getStudentClassrooms = async (studentId) => {
  const correction = {
    [':studentId']: studentId,
  }
  const url = autoReplace(ENDPOINTS_STUDENT.STUDENT_CLASSROOMS, correction)
  const { data } = await axios.get(url)
  return data
}

export const getStudentClassroomsByCourse = async ({ schoolId, courseId }) => {
  const correction = {
    [':courseId']: courseId,
    [':schoolId']: schoolId,
  }
  const url = autoReplace(
    ENDPOINTS_STUDENT.STUDENT_CLASSROOMS_BY_COURSE,
    correction
  )
  const { data } = await axios.get(url)
  return data
}

export const postSaveStudentClassroom = ({ classroomId, studentId }) => {
  const correction = {
    [':classroomId']: classroomId,
    [':studentId']: studentId,
  }
  const url = autoReplace(ENDPOINTS_STUDENT.SAVE_STUDENT_CLASSROOM, correction)
  return axios.post(url)
}

export const deleteStudentFromClass = async ({ classId, studentId }) => {
  const correction = {
    [':classId']: classId,
    [':userId']: studentId,
  }
  const url = autoReplace(
    ENDPOINTS_STUDENT.REMOVE_STUDENT_FROM_CLASS,
    correction
  )
  const { data } = await axios.delete(url)
  return data
}

export const getCheckClassCode = async ({ classCode, studentId }) => {
  const correction = {
    [':classCode']: classCode,
    [':studentId']: studentId,
  }
  const url = autoReplace(ENDPOINTS_STUDENT.CHECK_CLASS_CODE, correction)
  const { data } = await axios.get(url)
  return data
}

export const getCheckBookLicense = async ({
  classCode,
  licenseCode,
  studentId,
}) => {
  const correction = {
    [':classCode']: classCode,
    [':licenseCode']: licenseCode,
    [':studentId']: studentId,
  }
  const url = autoReplace(ENDPOINTS_STUDENT.CHECK_BOOK_LICENSE, correction)
  const { data } = await axios.get(url)
  return data
}

export const patchJoinClass = async ({ classCode, licenseCode, studentId }) => {
  const correction = {
    [':classCode']: classCode,
    [':licenseCode']: licenseCode,
    [':studentId']: studentId,
  }
  const url = autoReplace(ENDPOINTS_STUDENT.JOIN_CLASS, correction)
  const { data } = await axios.patch(url)
  return data
}
